import React, { useState } from "react";
import { Button } from "flowbite-react";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import LoadingOverlay from "./LoadingOverlay";
import ConfirmDialog from "./ConfirmDialog";

function ApproveMaterial() {
  const [req_id, setReqID] = useState("");
  const { user } = useSelector((state) => state.auth);
  const [tempArray, setTempArray] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [uploadPending, setUploadPending] = useState(false);

  function applyStripedStyle(index) {
    return index % 2 === 0 ? "border-b bg-gray-50" : " bg-white"; // Apply the striped-row class to even-indexed rows
  }

  const handleReq_Id = (e) => {
    const input = e.target.value;

    setReqID(input);
  };

  function formatDateTime(isoString) {
    const date = new Date(isoString);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  const fetchScannedData = async (groupId) => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `https://eps.elkomprintama.com/api/store/transaction_group/${groupId}`,
      );
      const data = response.data.result;

      // You can directly map it into the structure your table uses
      const formatted = data.map((item, index) => ({
        no: index + 1,
        product_id: item.product_id,
        product_name: item.product_name,
        temp_qty: item.stock_out, // assume pending amount is stock_out
        stock_in: 0,
        stock_out: item.stock_out,
        transaction_type: item.transaction_type,
        transaction_for: item.transaction_for,
        transaction_remark: item.transaction_remark,
        transaction_by: item.transaction_by,
        transaction_time: item.transaction_time,
        transaction_remark: item.transaction_remark,
      }));

      setTempArray(formatted);
    } catch (error) {
      toast.error("Failed to fetch scanned transaction.");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleScanSubmit = () => {
    if (!req_id) {
      toast.warning("No scanned group ID found.");
      return;
    }
    fetchScannedData(req_id);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!req_id) {
      toast.warning("No scanned group ID found.");
      return;
    }
    setUploadPending(true);
    setShowConfirm(true);
  };

  const submitApproval = async (e) => {
    try {
      setIsLoading(true);
      await axios.put(
        `https://eps.elkomprintama.com/api/store/stocks/approve`,
        {
          groupId: req_id,
          approvedBy: user.username, // Optional: if you track who approved
        },
      );

      toast.success("Stock request approved!");
      setReqID(""); // reset barcode input
      setTempArray([]); // clear table
    } catch (error) {
      console.error("Approval failed:", error);
      toast.error(
        "Failed to approve: " + error?.response?.data?.msg || error.message,
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        className={`w-full  rounded-lg bg-blue-600
        }`}
      >
        <label
          className={`block uppercase text-white  mb-2 tracking-wide  text-5xl text-center  font-bold `}
        >
          Approve Material
        </label>
      </div>
      <div
        className={`relative h-full  bg-gray-100 overflow-x-auto shadow-md px-5 rounded-lg `}
      >
        <form className="my-5" onSubmit={handleSubmit}>
          <div className="control w-full  ">
            <div className="flex flex-wrap -mx-3 mb-5">
              <div className="w-full   px-3">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor={`req_id`}
                >
                  SCAN REQUEST ID
                </label>
                <input
                  className="appearance-none block w-full border bg-white border-green-400 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                  id={`req_id`}
                  type="text"
                  placeholder="REQUEST ID"
                  value={req_id}
                  onChange={handleReq_Id}
                />
              </div>
            </div>
          </div>

          <div className="w-full ">
            <Button color="gray" fullSized onClick={handleScanSubmit}>
              CHECK
            </Button>
          </div>
          <div className="relative overflow-x-auto shadow-md my-6 sm:rounded-lg">
            <table className="text-sm text-left table-auto text-gray-500 dark:text-gray-400 w-full border-collapse">
              <thead className="sticky top-0 text-xs text-white uppercase bg-gray-600 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th
                    scope="col"
                    className="whitespace-nowrap px-5 py-5 flex-1 border-r"
                  >
                    No
                  </th>
                  <th
                    scope="col"
                    className="whitespace-nowrap px-5 flex-1 border-r"
                  >
                    Product ID
                  </th>
                  <th
                    scope="col"
                    className="whitespace-nowrap px-5 flex-1 border-r"
                  >
                    Product Name
                  </th>
                  <th
                    scope="col"
                    className="whitespace-nowrap px-5 flex-1 border-r"
                  >
                    Request Time
                  </th>
                  <th
                    scope="col"
                    className="whitespace-nowrap px-5 flex-1 border-r"
                  >
                    QTY
                  </th>

                  <th
                    scope="col"
                    className="whitespace-nowrap px-5 flex-1 border-r"
                  >
                    Remark
                  </th>
                  <th
                    scope="col"
                    className="whitespace-nowrap px-5 flex-1 border-r"
                  >
                    Customer
                  </th>
                  <th
                    scope="col"
                    className="whitespace-nowrap px-5 flex-1 border-r"
                  >
                    Input By
                  </th>
                  <th
                    scope="col"
                    className="whitespace-nowrap px-5 flex-1 border-r"
                  >
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {tempArray.map((data, index) => (
                  <tr
                    className={`py-6 text-xs border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 ${applyStripedStyle(
                      index,
                    )}`}
                    key={data.no}
                  >
                    <td className="whitespace-nowrap px-5 py-5 flex-1 border-r">
                      {data.no}
                    </td>
                    <td className="whitespace-nowrap px-5 flex-1 border-r">
                      {data.product_id}
                    </td>
                    <td className="whitespace-nowrap px-5 flex-1 border-r">
                      {data.product_name}
                    </td>
                    <td className="whitespace-nowrap px-5 flex-1 border-r">
                      {formatDateTime(data.transaction_time)}
                    </td>
                    <td className="whitespace-nowrap px-5 flex-1 border-r">
                      {data.temp_qty}
                    </td>

                    <td className="whitespace-nowrap px-5 flex-1 border-r">
                      {data.transaction_remark}
                    </td>
                    <td className="whitespace-nowrap px-5 flex-1 border-r">
                      {data.transaction_for}
                    </td>
                    <td className="whitespace-nowrap px-5 flex-1 border-r">
                      {data.transaction_by}
                    </td>
                    <td
                      className={`whitespace-nowrap font-bold px-5 flex-1 border-r ${
                        data.transaction_type === "CANCELLED"
                          ? "bg-red-600 text-white"
                          : data.transaction_type === "Stock Out"
                            ? "bg-green-500 text-white"
                            : "bg-yellow-200"
                      }`}
                    >
                      {data.transaction_type}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {isLoading && <LoadingOverlay message="loading..." />}
            {showConfirm && uploadPending && (
              <ConfirmDialog
                message="APPROVE REQUEST MATERIAL? CEK KEMBALI APAKAH REQUEST MATERIAL SUDAH SESUAI"
                onConfirm={() => {
                  setShowConfirm(false);
                  submitApproval();
                }}
                onCancel={() => {
                  setShowConfirm(false);
                  setUploadPending(false);
                }}
              />
            )}

            {tempArray.length > 0 && (
              <Button className="my-5" fullSized type="submit">
                APPROVE
              </Button>
            )}
          </div>
        </form>
      </div>
    </>
  );
}

export default ApproveMaterial;
